export const FIRST = 0;
export const LAST = Number.POSITIVE_INFINITY;
